import React from 'react'
import Head from 'next/head'
import { HeroModule } from '@pcln/marketing'
import { Box } from 'pcln-design-system'
import { IContentfulImageProps } from '@pcln/contentful-components'
import SearchForm from '@/components/SearchForm'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import HomeContent from './HomeContent'

const SunsetImage =
  'https://s1.pclncdn.com/design-assets/next-landing/assets/images/hero/pcln-hp-hero-sunset.png'

const defaultHeroProps = {
  searchForms: <SearchForm />,
  backgroundImage: {
    url: `${SunsetImage}?opto&auto=avif,webp`,
    altText: 'Woman watching sunset'
  },
  imageClassName: 'hero-image',
  shouldDisplaySilhouette: true
}

const protocolRegex = /(^\w+:|^)/g
const queryRegex = /\?(.*)/g

function trimContentfulAssetUrl(url: string) {
  return url.replace(protocolRegex, '').replace(queryRegex, '')
}

export default function HomeDesktop() {
  const heroImage = useContentfulVariation<IContentfulImageProps>('heroImage')
  const heroImageContentfulAsset = heroImage?.asset
  const heroProps = heroImageContentfulAsset?.file?.url
    ? {
        ...defaultHeroProps,
        backgroundImage: {
          url: `https:${trimContentfulAssetUrl(
            heroImageContentfulAsset.file.url
          )}?fm=webp&q=80`,
          altText: heroImageContentfulAsset.title ?? ''
        }
      }
    : { ...defaultHeroProps }
  return (
    <>
      <Head>
        <link rel="preload" as="image" href={heroProps.backgroundImage.url} />
      </Head>
      <Box style={{ 'overflow-x': 'hidden' }}>
        <Box height="100%" data-testid="hero-outer-box">
          <HeroModule {...heroProps} />
        </Box>
        <HomeContent />
      </Box>
    </>
  )
}
